import { render, staticRenderFns } from "./AddEmail.vue?vue&type=template&id=b588b380&"
import script from "./AddEmail.vue?vue&type=script&lang=js&"
export * from "./AddEmail.vue?vue&type=script&lang=js&"
import style0 from "./AddEmail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEmail.vue"
export default component.exports